import { ApiClient } from '../lib/api';
import {
  Building,
  BuildingSchema,
  CreateBuilding,
  CreateBuildingSchema,
  UpdateBuilding,
  UpdateBuildingSchema
} from '../models/building';

export class BuildingService {
  private readonly api: ApiClient;

  constructor(baseURL: string, stage: string) {
    this.api = new ApiClient(`${baseURL}/${stage}/buildings-service-${stage}`, stage);
  }

  private setDefaults(data: unknown): Building {
    return BuildingSchema.parse(data);
  }

  async getAllBuildings(): Promise<Building[]> {
    const buildings = await this.api.request(
      { method: 'GET', url: '/buildings' },
      BuildingSchema.array()
    );
    return buildings.map(building => this.setDefaults(building));
  }

  async getBuildingById(id: number): Promise<Building> {
    const building = await this.api.request(
      { method: 'GET', url: `/buildings/${id}` },
      BuildingSchema
    );
    return this.setDefaults(building);
  }

  async getBuildingsByClientId(clientId: number): Promise<Building[]> {
    const buildings = await this.api.request(
      { method: 'GET', url: `/buildings/client/${clientId}` },
      BuildingSchema.array()
    );
    return buildings.map(building => this.setDefaults(building));
  }

  async createBuilding(data: CreateBuilding): Promise<Building> {
    const building = await this.api.request(
      {
        method: 'POST',
        url: '/buildings',
        data: CreateBuildingSchema.parse(data)
      },
      BuildingSchema
    );
    return this.setDefaults(building);
  }

  async updateBuilding(id: number, data: UpdateBuilding): Promise<Building> {
    const building = await this.api.request(
      {
        method: 'PUT',
        url: `/buildings/${id}`,
        data: UpdateBuildingSchema.parse(data)
      },
      BuildingSchema
    );
    return this.setDefaults(building);
  }
} 